// import React from "react";
import { useEffect } from "react";
import { Scheduler } from "@aldabil/react-scheduler";
import "./styles.css";
import { API_URL } from "../../../services/apiConfig";
import { useNavigate } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import axiosInstance from "../../../services/axios.instance";
import { trackEvent } from "../../../services/events";

interface Order {
  orderNumber: string;
  oderStatus: string;
  statusChangeDate: string | null;
}

interface Event {
  event_id: number;
  title: string;
  start: Date;
  end: Date;
  orderNumber: string;
}

const BookingCalender = () => {
  const navigate = useNavigate();
  const {
    data: orders = [],
    isLoading,
    isError,
  } = useQuery<Order[]>({
    queryKey: ["orders"],
    queryFn: async () => {
      const response = await axiosInstance.get(API_URL.BOOKING_CALENDER);
      return response.data;
    },
  });

  useEffect(() => {
    const trackPageLoad = async () => {
      await trackEvent({
        event_name: {
          web: "Kirkos_BookCalendarScreen",
          app: "Kirkos_BookCalendarScreen_App",
        },
        event_category: "BookCalendar_Info",
        module: "BookCalendar",
        payload: {},
      });
    };
    trackPageLoad();
  }, []);

  if (isLoading) return <div>Loading...</div>;
  if (isError) return <div>Error fetching data</div>;

  const normalizedOrders: Order[] = Array.isArray(orders) ? orders : [];

  const events: Event[] = normalizedOrders
    .map((order: Order, index: number) => {
      const validDate =
        order.statusChangeDate && !isNaN(Date.parse(order.statusChangeDate));
      if (validDate) {
        const date = new Date(order.statusChangeDate!);
        return {
          event_id: index + 1,
          // title: `${order.oderStatus} , Order Id ${order.orderNumber}`,
          title: `Order Id ${order.orderNumber}`,
          start: date,
          end: date,
          orderNumber: order.orderNumber,
        };
      }
      return null;
    })
    .filter((event: any): event is Event => event !== null);

  return (
    <div className="booking-calendar">
      <Scheduler
        view="month"
        editable={false}
        deletable={false}
        agenda={false}
        // height={500}
        month={{
          weekDays: [0, 1, 2, 3, 4, 5, 6],
          weekStartOn: 0,
          startHour: 0,
          endHour: 24,
          navigation: true,
          disableGoToDay: false,
        }}
        week={{
          weekDays: [0, 1, 2, 3, 4, 5, 6],
          weekStartOn: 0,
          startHour: 0,
          endHour: 24,
          step: 60,
          navigation: true,
          disableGoToDay: false,
        }}
        day={{
          startHour: 0,
          endHour: 24,
          step: 60,
        }}
        events={events}
        onEventClick={(event) => {
          const orderNo = (event as any).orderNumber;
          if (orderNo) {
            navigate(
              `/customer/order/details?OrderId=${encodeURIComponent(orderNo)}`
            );
          }
        }}
      />
    </div>
  );
};

export default BookingCalender;
